import { Box, Button, Flex, IconButton, Image, Text } from '@chakra-ui/react'
import { getCurrentMonthWeek } from './DateUtils'
import { DateTime } from 'luxon'

const noFilter = true

const Appbar = ({currentDate, setCurrentDate, scrollToToday}) => {
  const renderDate = () => {
    if (!currentDate) return ''
    return currentDate.toFormat('MMMM yyyy')
  }

  const renderWeek = () => {
    if (!currentDate) return ''
    return `Week ${getCurrentMonthWeek(currentDate)}`
  }

  return (
    <>
      <Flex alignItems='center'>
        <Text
          color='brandTextBlack'
          fontSize='2rem'
          fontWeight='500'
        >
          {renderDate()}
        </Text>
        <Text
          color='brandTextGrey'
          fontSize='2rem'
          fontWeight='500'
          ml={3}
        >
          {renderWeek()}
        </Text>

        <Box ml='auto' />

        <IconButton
          boxSize={6}
          p={2}
          minH={8}
          minW={0}
          icon={<Image src='/assets/icons/arrowLeft.svg' />}
          colorScheme='brandBackground2'
          onClick={() => setCurrentDate(DateTime.fromMillis(currentDate.toMillis() - 604800000))}
        />
        <Box ml={1} />
        <IconButton
          boxSize={6}
          p={2}
          minW={0}
          minH={8}
          icon={<Image src='/assets/icons/arrowRight.svg' />}
          colorScheme='brandBackground2'
          onClick={() => setCurrentDate(DateTime.fromMillis(currentDate.toMillis() + 604800000))}
        />
      
        <Box ml={4} />

        <Button
          px={3}
          py={'8.5px'}
          h='35px'
          color='brandTextBlack'
          border='1px solid rgba(0, 0, 0, 0.12)'
          borderRadius='8px'
          colorScheme='brandBackground2'
          onClick={() => scrollToToday()}
        >
        Today
        </Button>
      </Flex>
      
      <Flex flexDirection='column' position='relative'>
        <Flex mt={5} minH='35px' overflowX='scroll' className='noScrollbar'>
          <Box mr={2}>
            <Button  
              p={3}
              h='35px'
              color='brandTextBlack'
              borderRadius='8px'
              colorScheme='brandBackground2'
              bg={noFilter ? '#EFF0F7' : 'initial'}
              border={noFilter ? '1px solid rgba(0, 0, 0, 0.12)' : '1px solid #FBFBFB'}
            >
              All
            </Button>
          </Box>
        </Flex>
      </Flex>
    </>
  )
}

export default Appbar